import { unref as _unref, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-43bf5395"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "layouts"
};
const _hoisted_2 = {
  class: "container"
};
const _hoisted_3 = {
  class: "page-bottom"
};
import TopBar from './TopBar';
import NavList from './NavList';
import PageTitle from './PageTitle';
export default {
  __name: 'Layouts',
  setup(__props) {
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(NavList)), _createElementVNode("div", _hoisted_2, [_createVNode(_unref(TopBar)), _createVNode(_unref(PageTitle)), _createElementVNode("div", _hoisted_3, [_createVNode(_component_router_view, {
        class: "page-detail"
      }, {
        default: _withCtx(({
          Component
        }) => [(_openBlock(), _createBlock(_KeepAlive, null, [(_openBlock(), _createBlock(_resolveDynamicComponent(Component)))], 1024))]),
        _: 1
      })])])]);
    };
  }
};